export default __webpack_public_path__ + "15344ff7516b2227604e845f8406e859.png";